import Button from 'components/Button'
import Divider from 'components/common/Divider'
import Typography from 'components/common/Typography'
import { useCollectiveDemoContext } from 'context/CollectiveDemoContext'
import Image from 'next/image'

export const DemoWalletConnecting: React.FC = () => {
  const host = window.location.hostname

  const { setDemoWalletLinked, possibleMembers, setDemoWalletLinking } =
    useCollectiveDemoContext()

  return (
    <div className="absolute top-1/4 right-15 h-[500px] bg-gray-100 p-2 rounded-md border border-gray-300 z-40 flex flex-col space-between shadow-common w-[210px]">
      <div className="flex flex-col items-center text-center mb-4 flex-1">
        <Typography>Demo Wallet Connect Request</Typography>

        <div className="my-16 p-1 border border-gray-300 rounded-full w-full text-center flex justify-between items-center overflow-hidden gap-3">
          <Image
            src="/static/favicon.png"
            width={30}
            height={30}
            alt="Upstream favicon"
          />
          <Typography truncate={1}>{host}</Typography>
          <div />
        </div>
      </div>

      <div className="text-center mb-8 flex-1">
        <Typography size="xl">Connect to Account</Typography>

        <Typography truncate={1} size="xl">
          ({possibleMembers[0].address.slice(0, 6)}...
          {possibleMembers[0].address.slice(
            possibleMembers[0].address.length - 6
          )}
          )
        </Typography>
      </div>

      <Divider />

      <div className="flex items-center mb-4 flex-col justify-end">
        <Typography size="xs" color="error">
          (Continue the demo by clicking connect)
        </Typography>
      </div>

      <div className="flex justify-between">
        <Button
          color="outline"
          label="Cancel"
          onClick={() => {
            setDemoWalletLinking('init')
            setDemoWalletLinked(false)
          }}
        />
        <Button
          color="outline"
          size="sm"
          label={'Connect Demo Wallet'}
          onClick={() =>
            setTimeout(() => {
              setDemoWalletLinked(true)
            }, 500)
          }
        />
      </div>
    </div>
  )
}
